import { render, staticRenderFns } from "./DialogScrollingText.vue?vue&type=template&id=f65c3770"
import script from "./DialogScrollingText.vue?vue&type=script&lang=js"
export * from "./DialogScrollingText.vue?vue&type=script&lang=js"
import style0 from "./DialogScrollingText.vue?vue&type=style&index=0&id=f65c3770&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports